import { useEffect } from 'react';

interface ToastProps {
  message: string;
  type: 'error' | 'success';
  onDismiss: () => void;
}

export function Toast({ message, type, onDismiss }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, 4000);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)',
        left: '50%',
        transform: 'translateX(-50%)',
        maxWidth: '400px',
        width: 'calc(100% - 32px)',
        padding: 'var(--space-3) var(--space-4)',
        borderRadius: 'var(--radius-md)',
        backgroundColor: type === 'error' ? 'var(--color-danger)' : 'var(--color-success)',
        color: '#fff',
        fontSize: 'var(--font-size-sm)',
        fontWeight: 500,
        zIndex: 9999,
        textAlign: 'center',
      }}
    >
      {message}
    </div>
  );
}
